import React from "react";
import { NavLink } from "react-router-dom";
import AlertCard from "./panel/alertCard";
import BunnerUsersSmall from "./panel/bunnerUsersSmall";
import BuyPanel from "./panel/buyPanel";
import CoverBunner from "./panel/coverBunner";
import DescriptionPanel from "./panel/descriptionPanel";
import DescriptionRegister from "./panel/descriptionRegister";
// import MarketingTechniques from "./panel/marketingTechniques";
import MyCustomer from "./panel/myCustomer";
import PanelFeatures from "./panel/panelFeatures";
import Possibilities from "./panel/possibilities";
import SliderLab from "./panel/sliderLab";
import SMSPluginLab from "./panel/sMSPluginLab";
import VOP from "./panel/vop";
import direction from "../../service/direction.json";
const Home = () => {
  return (
    <div>
      <div className="text-center">
        <span style={{ fontSize: "62px" }}>
          <b>پنل اس ام اس سایه بان</b>
        </span>
        <br />
        <span className="mt-4" style={{ fontSize: "28px" }}>
          هر چیزی با پنل اس ام اس قابل تصور است!
        </span>
        <p />
        <DescriptionPanel />
        <BunnerUsersSmall />
        <AlertCard
          color="#C0E8D5"
          header="10 روز گارانتی بدون قید و شرط"
          title="با خیال راحت ثبت نام کنید!"
          description="پنل اس ام اس را خریداری کنید و تا 10 روز استفاده و تست کنید. اگر به هردلیلی از سامانه ناراضی بودید هزینه پنل را کامل عودت می دهیم."
        />
        <CoverBunner
          title="سامانه پیامکی مناسب خود را انتخاب کنید"
          description={
            <div className="input-group">
              <div className="col-sm-7" style={{ fontSize: "20px" }}>
                با توجه به امکاناتی که برایتان ضروری است و همنچنین تعداد ارسال،
                پنل ارسال پیامک خود را انتخاب کنید. اگر احتمال میدهید تعداد
                ارسال زیادی خواهید داشت، پنل های بالاتر درنهایت برایتان باصرفه
                تر خواهد بود چون هرچه پنل بالاتری تهیه کنید، پیامکها را ارزانتر
                ارسال خواهید کرد. فراموش نکنید که هزینه اولیه پنل را فقط یکبار
                پرداخت میکنید و دیگر نیازی به تمدید نخواهد بود. (پنل دائمی)
              </div>
              <div className="text-center">
                <img
                  src={`${direction.ImgDesign}analyse-sms.png`}
                  alt="سایه بان"
                />
                <br />
                <br />
                <NavLink to="/FacilitiesAndTariffs" className="btn btn-info">
                  بررسی بیشتر و انتخاب پنل
                </NavLink>
              </div>
              <div className="text-center">
                <img
                  src={`${direction.ImgDesign}test-sms.png`}
                  alt="سایه بان"
                />
              </div>
            </div>
          }
        />
        <p />
        <VOP />
        <DescriptionRegister />
        <Possibilities />
        <SMSPluginLab />
        <SliderLab />
        <br />
        <br />
        <br />
        {/* <MarketingTechniques /> */}
        <PanelFeatures />
        <br />
        <br />
        <br />
        <MyCustomer />
        <br />
        <br />
        <br />
        <BuyPanel />
      </div>
    </div>
  );
};

export default Home;
